export default __webpack_public_path__ + "static/media/institute-12-min.9e609f36.webp";